export const CHAT_NOTES_WEBK_SUPPORTED_METHODS = new Set([
  'help.getConfig',
  'help.getAppConfig',
  'updates.getState',
  'messages.getDialogFilters',
  'messages.getSuggestedDialogFilters',
  'messages.updateDialogFilter',
  'messages.updateDialogFiltersOrder',
  'users.getUsers',
  'users.getFullUser',
  'photos.getUserPhotos',
  'messages.getPeerSettings',
  'account.getNotifySettings',
  'account.updateNotifySettings',
  'account.updateStatus',
  'messages.getDialogs',
  'messages.getPeerDialogs',
  'messages.getHistory',
  'messages.getMessages',
  'messages.getScheduledHistory',
  'messages.getScheduledMessages',
  'messages.sendScheduledMessages',
  'messages.deleteScheduledMessages',
  'messages.search',
  'messages.searchGlobal',
  'messages.getSearchCounters',
  'messages.getAllDrafts',
  'messages.clearAllDrafts',
  'messages.saveDraft',
  'messages.sendMessage',
  'messages.sendMedia',
  'messages.sendMultiMedia',
  'messages.editMessage',
  'messages.forwardMessages',
  'messages.updatePinnedMessage',
  'messages.unpinAllMessages',
  'messages.sendReaction',
  'messages.getAvailableReactions',
  'messages.getTopReactions',
  'messages.getRecentReactions',
  'messages.getDefaultTagReactions',
  'messages.getSavedReactionTags',
  'messages.getMessagesReactions',
  'messages.getMessageReactionsList',
  'messages.getMessageEditData',
  'messages.setTyping',
  'messages.deleteMessages',
  'messages.deleteHistory',
  'messages.readHistory',
  'upload.saveFilePart',
  'upload.saveBigFilePart',
  'upload.getFile'
] as const);

export function isChatNotesWebKSupportedMethod(method: string): boolean {
  return CHAT_NOTES_WEBK_SUPPORTED_METHODS.has(method as never);
}
